import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import map from 'lodash/map';

import Mission from 'models/task/Mission';
import TaskState from 'models/task/state/TaskState';

import { Currency } from 'components/_/common/currency/Currency';
import { Button } from '../../../../../_/common/button/Button';
import { taskAvailability } from 'i18n/util/taskAvailability';

export const Tile = injectIntl(({ task: _task, intl }) => {
	const isUnavailable = _task.state().status(_task) === TaskState.STATUS_UNAVAILABLE;
	const message = taskAvailability(_task, intl.locale);

	return (
		<div className="col-12 col-xs-8 col-sm-24 col-md-12 col-lg-6 col-xxl-4 mb-4 mb-sm-5">
			<div className="mx-0 mx-sm-3 h-100">
				<NavLink
					to={isUnavailable ? '#' : `/${_task instanceof Mission ? 'mission' : 'task'}/${_task.id()}/details`}
					onClick={event => isUnavailable && event.preventDefault()}
					className={classnames('position-relative d-block h-100', {
						[`task--${_task.state().status(_task)}`]: true,
					})}
				>
					<div className="task__status rounded-circle"></div>
					<div
						className={classnames('tile collectionMission__tile rounded h-100', {
							disable: !_task.state().hasStatus(_task, ['available', 'retention', 'periodicity']),
						})}
					>
						<div className="tile__front d-flex flex-column">
							<div
								className="tile__image background-image size--cover rounded-top"
								style={{
									backgroundImage: `url(${_task.listImage()})`,
								}}
							/>
							<div className="task-front d-flex flex-column align-items-center justify-content-start flex-grow-1 px-4 py-2 py-sm-4">
								<p className="task-name text-center fs-5">{_task.name()}</p>
								{message ? (
									<p className="task-availability mt-2 text-center fs-4">
										<FormattedMessage
											id={`task-details.collection-mission.content.availability.prefix.${message.id}`}
										/>
										<div className="mt-1">
											<FormattedMessage
												id={`task-details.collection-mission.content.availability.value.${message.id}`}
												values={message.values}
											/>
										</div>
									</p>
								) : null}
							</div>
						</div>
						<div className="tile__back d-none d-sm-block">
							<div className="d-flex flex-column h-100">
								<div className="d-flex flex-column justify-content-between px-4 pt-4 pb-3 flex-grow-1">
									<p className="task-name fs-5 text-center mb-4">{_task.name()}</p>
									{_task.state().hasCompletionEarnings() && _task.state().showPoints(_task) && (
										<div>
											<p className="task-earnings text-center mb-3">
												<FormattedMessage
													id={`task-details.collection-mission.content.gain-for-complete-${
														_task instanceof Mission ? 'mission' : 'task'
													}`}
												/>
											</p>
											<div className="d-flex flex-wrap justify-content-center fs-4">
												{map(_task.earningsInformation().completion.values(), currency => (
													<Currency
														key={currency.codeName()}
														currency={currency.codeName()}
														value={currency.value()}
														className="mr-2"
													/>
												))}
											</div>
										</div>
									)}
								</div>
								{!_task.state().hasStatus(_task, ['completed']) && (
									<div className="tile__button fs-5 text-center px-4 py-3">
										<Button color="interactive">
											{_task.state().hasStatus(_task, ['retention']) ? (
												<FormattedMessage id="task-details.collection-mission.button.repeat" />
											) : (
												<FormattedMessage id="task-details.collection-mission.button.do" />
											)}
										</Button>
									</div>
								)}
							</div>
						</div>
					</div>
				</NavLink>
			</div>
		</div>
	);
});

export const CollectionTiles = ({ task }) => {
	return (
		<div className="collectionMission__list flex-grow-1 my-4 my-sm-0">
			<div className="row">
				{task.tasks().map(_task => (
					<Tile key={_task.id()} task={_task} />
				))}
			</div>
		</div>
	);
};
